module.exports = __webpack_public_path__ + "static/blurr-feathers-e24a43bb0fbce83a6df45003aae8813e.png";